import React, { type ReactElement, useMemo } from 'react'
import { type SerializedStyles, css } from '@emotion/react'
import { gridHeaderRowStyles } from '../utils/grid.styles'
import { type GridDatum, type GridHeaderGroup } from '../utils/grid.types'
import { GridHeaderColumnCell } from './GridHeaderColumnCell'

interface Props<TDatum extends GridDatum> extends GridHeaderGroup<TDatum> {}

export const GridHeaderGroupRow = <TDatum extends GridDatum>({
  headers,
  getHeaderGroupProps,
}: Props<TDatum>): ReactElement => {
  const renderedCells = headers.map(column => <GridHeaderColumnCell key={column.id} {...column} />)
  const { style, ...headerGroupProps } = getHeaderGroupProps()
  const dynamicStyles = css(style as SerializedStyles, gridHeaderRowStyles)

  return (
    <div {...headerGroupProps} css={dynamicStyles}>
      {renderedCells}
    </div>
  )
}
